// Column ids — used by the column defs and by the sort payload.
export const INCOMING_SHIPMENT_COLUMNS = Object.freeze({
  shipmentId: 'shipmentId',
  materialName: 'materialName',
  totalContractsLinked: 'totalContractsLinked',
  totalDeclarationsReceived: 'totalDeclarationsReceived',
  supplierName: 'supplierName',
  status: 'status',
  facilityName: 'facilityName',
  terminal: 'terminal',
  vessel: 'vessel',
  unit: 'unit',
  unitType: 'unitType',
  shipmentQuantity: 'shipmentQuantity',
  receivedDeclarationQuantity: 'receivedDeclarationQuantity',
  pendingQuantity: 'pendingQuantity',
  availableQuantity: 'availableQuantity',
  ghgEmissions: 'ghgEmissions',
  ghgEmissionSavings: 'ghgEmissionSavings',
  rawMaterialType: 'rawMaterialType',
  countryOfOrigin: 'countryOfOrigin',
  feedstockCategory: 'feedstockCategory',
  allocationPreference: 'allocationPreference',
  dateOfDischarge: 'dateOfDischarge',
  dateOfDispatch: 'dateOfDispatch',
  daysLeft: 'daysLeft',
  discrepancies: 'discrepancies',
});

// Column id → the ShipmentOrderByField the server accepts; anything missing gets no sort arrow.
// TODO: shipmentQuantity sorts per unit type (…Working/…Declaration/…Tracking) — needs
// the sort field to follow the unit column's selection.
export const INCOMING_SHIPMENT_SORT_FIELDS = Object.freeze({
  [INCOMING_SHIPMENT_COLUMNS.shipmentId]: 'shipmentId',
  [INCOMING_SHIPMENT_COLUMNS.materialName]: 'material',
  [INCOMING_SHIPMENT_COLUMNS.supplierName]: 'sentBySupplier',
  [INCOMING_SHIPMENT_COLUMNS.vessel]: 'vessel',
  [INCOMING_SHIPMENT_COLUMNS.dateOfDispatch]: 'dateOfDispatch',
  [INCOMING_SHIPMENT_COLUMNS.dateOfDischarge]: 'dateOfDischarge',
});
